import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Popover,
  Box,
  Chip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Driver } from "@lib/types/driver";
import InformationView from "./InformationView";
import { parseValue } from "@lib/utils/string";

interface DriverCardProps {
  driver: Driver;
}

const DriverCard: React.FC<DriverCardProps> = ({ driver }) => {
  const { t } = useTranslation();

  const driver_info = [
    { label: t("user.drivers.name"), value: driver.name, columnSize: 4 },
    { label: t("user.drivers.code"), value: driver.code, columnSize: 4 },
    {
      label: t("user.drivers.parameterNumber"),
      value: driver.parameter_number,
      columnSize: 4,
    },
    {
      label: t("user.drivers.phone"),
      value: parseValue(driver.phone),
      columnSize: 4,
    },
  ];

  return (
    <Card sx={{ width: "100%", margin: 1 }}>
      <CardContent>
        <InformationView data={driver_info} columns={8} />
      </CardContent>
    </Card>
  );
};

export default DriverCard;
